/*
 * Constants.
 */

export const emojiAllowedAttributes = ['front-emoji-shortcode'];
export const inlineAttachmentAllowedAttributes = ['front-cid', 'front-name'];

/*
 * Helpers.
 */

export function wrapMessageWithDivId(html: string, messageId?: number) {
  if (!messageId) {
    return html;
  }

  // If we have a message ID, wrap the HTML with a special div
  // so the styles prefixed by the sanitizer work properly.
  return `<div id="fae_${messageId.toString(36)}">${html}</div>`;
}
